module.exports = __webpack_public_path__ + "static/media/rnsHero.bde845e7.png";